import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-equipment-grp',
  templateUrl: './equipment-grp.component.html',
  styleUrls: ['./equipment-grp.component.css']
})
export class EquipmentGrpComponent implements OnInit {
    public equipmentGrpId: string;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.equipmentGrpId = this.stateService.getStateParams()['equipmentgrp_id'];
    }

    private async loadEdit() {
        if (!!this.equipmentGrpId) {
            this.edit = (await this.datatask.Post(2049, { equipmentgrp_id: this.equipmentGrpId }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2050, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    equipmentgrp_id: string;
    equipmentgrp_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('equipmentGrp', {
//        templateUrl: 'views/components/views/equipmentGrp/equipmentGrp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'equipmentGrpService', function ($stateParams, stateService, translateService, modalService, equipmentGrpService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let equipmentGrpId = $stateParams.equipmentgrp_id;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                equipmentGrpId: equipmentGrpId,
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await equipmentGrpService.getEdit({ equipmentgrp_id: equipmentGrpId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                equipmentGrpService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
